//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyBasePage from "../components/MyBasePage";
import Balance from "./components/balance.vue";

export default {
  name: "funds",
  components: {
    MyBasePage,
    Balance,
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/funds/index.vue